export default "__VITE_ASSET__JlXw9xGw__"